module.exports = __webpack_public_path__ + "img/logo-nganluong1.4f6b0dc0.png";